// <!-- スクロールトリガーでfade-up -->
// <div data-gsap-anim="fade-up" class="box">スクロールでフェードアップ</div>

// <!-- 子要素にstaggerでzoom-fade -->
// <div data-gsap-anim="zoom-fade" data-gsap-options='{"staggerChildren":true,"stagger":0.2}'>
//   <span>子1</span>
//   <span>子2</span>
//   <span>子3</span>
// </div>

// <!-- durationやeaseをカスタム -->
// <div data-gsap-anim="slide-left" data-gsap-options='{"duration":1,"ease":"elastic.out(1, 0.3)"}'>
//   カスタムスライド
// </div>

// <!-- モーダルの中やボタンクリック後に発火させたい場合 -->
// <button id="openModal">モーダルを開く</button>
// <div id="modal" data-gsap-anim="zoom-fade" style="display:none;">モーダル内容</div>
/////////////////////////////////////////////////
// // ページ読み込み時に一括初期化
// initGsapAnimations({
//   start: 'top 90%',
//   once: true,
//   duration: 0.8,
//   ease: 'power3.out',
// });

// // モーダル開閉時にアニメ実行例
// document.getElementById('openModal').addEventListener('click', () => {
//   const modal = document.getElementById('modal');
//   modal.style.display = 'block';

//   // アニメーションをトリガー（fade-in & zoom）
//   triggerAnimationBySelector('#modal');
// });

// inc_gsapAnimController.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const defaultOptions = {
  start: 'top 80%',
  ease: 'power2.out',
  duration: 0.3,
  stagger: 0.15,
  once: true,
};

const animationPresets = {
  'fade-up': {
    from: { opacity: 0, y: 40 },
    to: { opacity: 1, y: 0 },
  },
  'fade-down': {
    from: { opacity: 0, y: -40 },
    to: { opacity: 1, y: 0 },
  },
  'zoom-fade': {
    from: { opacity: 0, scale: 0.8 },
    to: { opacity: 1, scale: 1 },
  },
  'slide-left': {
    from: { opacity: 0, x: 40 },
    to: { opacity: 1, x: 0 },
  },
  'slide-right': {
    from: { opacity: 0, x: -40 },
    to: { opacity: 1, x: 0 },
  },
  'zoom-in-shrink': {
  from: { opacity: 0, scale: 1.5 },
  to:   { opacity: 1, scale: 1 },
  },

};

// メインコントローラー関数
export function initGsapAnimations(globalConfig = {}) {
  const config = { ...defaultOptions, ...globalConfig };

  // アニメーション対象を全取得
  const animElements = document.querySelectorAll('[data-gsap-anim]');

  animElements.forEach(el => {
    const animType = el.dataset.gsapAnim;
    const preset = animationPresets[animType];
    if (!preset) {
      console.warn(`GSAP Anim: preset not found for "${animType}"`);
      return;
    }

    // 個別オプション(JSON)があればパース
    let localOpts = {};
    if (el.dataset.gsapOptions) {
      try {
        localOpts = JSON.parse(el.dataset.gsapOptions);
      } catch {
        console.warn('GSAP Anim: data-gsap-options JSON parse error');
      }
    }

    // ScrollTrigger 設定を組み立て
    const scrollTriggerConfig = {
      trigger: el,
      start: localOpts.start || config.start,
      toggleActions: config.once ? 'play none none none' : 'play reverse play reverse',
      once: config.once,
      markers: localOpts.markers || false,
    };

    // 複数子要素に対するstagger対応（子がある場合）
    let targets = el;
    if (localOpts.staggerChildren) {
      targets = el.children;
    }

    // 初期状態セット
    gsap.set(targets, preset.from);

    // アニメーション実行
    gsap.to(targets, {
      ...preset.to,
      duration: localOpts.duration || config.duration,
      ease: localOpts.ease || config.ease,
      stagger: localOpts.stagger !== undefined ? localOpts.stagger : config.stagger,
      scrollTrigger: scrollTriggerConfig,
      onComplete: () => {
        if (localOpts.onComplete) {
          localOpts.onComplete();
        }
      },
    });
  });
}

// モーダルなど外部トリガーでアニメ発火用のユーティリティ関数
export function triggerAnimationBySelector(selector) {
  const el = document.querySelector(selector);
  if (!el) return;

  const animType = el.dataset.gsapAnim;
  const preset = animationPresets[animType];
  if (!preset) {
    console.warn(`GSAP Anim: preset not found for "${animType}"`);
    return;
  }

  gsap.fromTo(
    el,
    preset.from,
    {
      ...preset.to,
      duration: defaultOptions.duration,
      ease: defaultOptions.ease,
    }
  );
}
